export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/',
    meta: {roleId: 1},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/profile',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1},
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/dashboard',
    meta: { breadcrumb: true, requiresAuth: true, roleId: 1 },
    name: 'Dashboard',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Dashboard.vue`
    )
  },
  {
    path: '/don-hang/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, createButtonText: 'Tạo đơn mới', roleId: 32 },
    name: 'OrderList',
    component: () => import(
      `@/views/Order/OrderList.vue`
    )
  },
  {
    path: '/don-hang/:Pid',
    meta: { breadcrumb: false, requiresAuth: true, roleId: 4096 },
    name: 'OrderDetail',
    component: () => import(
      `@/views/Order/OrderDetail.vue`
    )
  },
  {
    path: '/khach-hang/quan-ly-khach-hang',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'CustomerList',
    component: () => import(
      `@/views/Customer/CustomerList.vue`
    )
  },
  {
    path: '/khach-hang/quan-ly-khach-hang/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: 'Reset password', createButtonIcon: 'refresh', roleId: 8 },
    name: 'CustomerDetail',
    component: () => import(
      `@/views/Customer/CustomerDetail.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-nap-tien/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'RechargeHistory',
    component: () => import(
      `@/views/RechargeHistory/list.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-nap-tien/:Pid',
    meta: { title: 'Chi tiết nạp tiền', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 8 },
    name: 'RechargeDetail',
    component: () => import(
      `@/views/RechargeHistory/detail.vue`
    )
  },
  {
    path: '/nap-tien/',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, saveButtonText: 'NẠP TIỀN', roleId: 16 },
    name: 'RechargeNew',
    component: () => import(
      `@/views/RechargeHistory/detail.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-thanh-toan/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'PaymentHistory',
    component: () => import(
      `@/views/PaymentHistory/PaymentHistoryList.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-rut-tien/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'WithdrawHistory',
    component: () => import(
      `@/views/WithdrawHistory/list.vue`
    )
  },
  {
    path: '/thanh-toan-don-hang/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 128 },
    name: 'PayOrderList',
    component: () => import(
      `@/views/PayOrder/list.vue`
    )
  },
  {
    path: '/quan-ly-ma-van-don/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 512 },
    name: 'Transaction',
    component: () => import(
      `@/views/Transaction/list.vue`
    )
  },
  {
    path: '/ky-gui/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 64 },
    name: 'Deposit',
    component: () => import(
      `@/views/Deposit/list.vue`
    )
  },
  {
    path: '/ky-gui/:Pid',
    meta: { title: 'Chi tiết ký gửi', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 64 },
    name: 'DepositDetail',
    component: () => import(
      `@/views/Deposit/detail.vue`
    )
  },
  {
    path: '/khieu-nai/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4096 },
    name: 'Complain',
    component: () => import(
      `@/views/Complain/list.vue`
    )
  },
  {
    path: '/khieu-nai/:Pid',
    meta: { title: 'Chi tiết khiếu nại', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 4096 },
    name: 'ComplainDetail',
    component: () => import(
      `@/views/Complain/detail.vue`
    )
  },
  {
    path: '/quan-ly-kho/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1024 },
    name: 'StoreManager',
    component: () => import(
      `@/views/StoreManager/list.vue`
    )
  },
  {
    path: '/nhap-kho-vn/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập kho', refreshButton: true, roleId: 256 },
    name: 'StoreManagerVN',
    component: () => import(
      `@/views/StoreManagerVn/list.vue`
    )
  },
  {
    path: '/nhap-kho-vn/:Pid',
    meta: {title: 'Chi tiết nhập kho', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập bao mới', roleId: 256 },
    name: 'StoreManagerVNDetail',
    component: () => import(
      `@/views/StoreManagerVn/detail.vue`
    )
  },
  {
    path: '/quan-ly-bao-hang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2048 },
    name: 'BigPackage',
    component: () => import(
      `@/views/BigPackage/list.vue`
    )
  },  
  {
    path: '/cai-dat/phi-can-nang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2 },
    name: 'FeeWeightList',
    component: () => import(
      `@/views/FeeWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 2 },
    name: 'FeeWeightDetail',
    component: () => import(
      `@/views/FeeWeight/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-mua-hang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2 },
    name: 'FeeBuyList',
    component: () => import(
      `@/views/FeeBuy/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-mua-hang/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 2 },
    name: 'FeeBuyDetail',
    component: () => import(
      `@/views/FeeBuy/detail.vue`
    )
  },
  {
    path: '/cai-dat/cau-hinh-chung',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 2},
    name: 'Configuration',
    component: () => import(
      `@/views/Configuration/detail.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2 },
    name: 'StaffList',
    component: () => import(
      `@/views/Staff/list.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 2 },
    name: 'StaffDetail',
    component: () => import(
      `@/views/Staff/detail.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-level/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'CustomerLevel',
    component: () => import(
      `@/views/CustomerLevel/CustomerLevelList.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-level/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 8 },
    name: 'CustomerLevelDetail',
    component: () => import(
      `@/views/CustomerLevel/CustomerLevelDetail.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'WarehouseList',
    component: () => import(
      `@/views/Warehouse/list.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 8 },
    name: 'WarehouseDetail',
    component: () => import(
      `@/views/Warehouse/detail.vue`
    )
  },
  {
    path: '/cai-dat/phuong-thuc-van-chuyen/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'ShippingMethodList',
    component: () => import(
      `@/views/ShippingMethod/list.vue`
    )
  },
  {
    path: '/cai-dat/phuong-thuc-van-chuyen/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 8 },
    name: 'ShippingMethodDetail',
    component: () => import(
      `@/views/ShippingMethod/detail.vue`
    )
  },
  {
    path: '/thong-bao/',
    meta: { title: 'Thông báo', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1 },
    name: 'NotificationList',
    component: () => import(
      `@/views/Notification/list.vue`
    )
  },
  {
    path: '/bao-cao/loi-nhuan-dat-hang/',
    meta: { title: 'Thống kê lợi nhuận đặt hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 1 },
    name: 'thong-ke-loi-nhuan-dat-hang',
    component: () => import(
      `@/views/Reports/thong-ke-loi-nhuan-dat-hang.vue`
    )
  },
  {
    path: '/bao-cao/phi-mua-hang/',
    meta: { title: 'Thống kê phí mua hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 2 },
    name: 'thong-ke-phi-mua-hang',
    component: () => import(
      `@/views/Reports/thong-ke-phi-mua-hang.vue`
    )
  },
  {
    path: '/bao-cao/phi-van-chuyen/',
    meta: { title: 'Thống kê phí vận chuyển', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 4 },
    name: 'thong-ke-phi-van-chuyen',
    component: () => import(
      `@/views/Reports/thong-ke-phi-van-chuyen.vue`
    )
  },
  {
    path: '/bao-cao/tien-te/',
    meta: { title: 'Thống kê tiền tệ', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'thong-ke-tien-te',
    component: () => import(
      `@/views/Reports/thong-ke-tien-te.vue`
    )
  },
  {
    path: '/bao-cao/tai-chinh/',
    meta: { title: 'Báo cáo tài chính', breadcrumb: true, requiresAuth: true, roleId: 4, reportRoleId: 16, saveButton: true, saveButtonText: 'Chuyển tiền', saveButtonIcon: 'refresh', createButton: true, createButtonText: 'Thu Chi', createButtonIcon: 'monetization_on'},
    name: 'bao-cao-tai-chinh',
    component: () => import(
      `@/views/Reports/bao-cao-tai-chinh.vue`
    )
  },
  {
    path: '/bao-cao/nap-tien/',
    meta: { title: 'Thống kê phí vận chuyển', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'bao-cao-nap-tien',
    component: () => import(
      `@/views/Reports/bao-cao-nap-tien.vue`
    )
  },
  {
    path: '/bao-cao/doanh-thu/',
    meta: { title: 'Báo cáo doanh thu', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'bao-cao-tong-hop',
    component: () => import(
      `@/views/Reports/bao-cao-tong-hop.vue`
    )
  },
];
